// hooks/useDocumentStatus.ts
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import { getDocumentStatus } from '../services/documentService';

export interface DocumentStatus {
  status: string;
}

/** queryKey / queryFn を除外したオプション型 */
type StatusQueryOptions = Omit<
  UseQueryOptions<
    DocumentStatus,
    Error,
    DocumentStatus,
    ['documentStatus', number]
  >,
  'queryKey' | 'queryFn'
>;

export const useDocumentStatus = (
  documentId: number,
  options?: StatusQueryOptions // ★ 狭い型で受け取る
) => {
  return useQuery<
    DocumentStatus,
    Error,
    DocumentStatus,
    ['documentStatus', number]
  >({
    queryKey: ['documentStatus', documentId],
    queryFn: async () => {
      const res: AxiosResponse<DocumentStatus> =
        await getDocumentStatus(documentId);
      return res.data;
    },
    staleTime: 60_000,
    retry: 1,
    refetchOnWindowFocus: false,
    ...options, // ← ここで上書き可
  });
};
